import { LogoLocavibeBase64 } from "@/common/helpers/logo-locavibe-base64";

export const Header = () => {
  return (
    <div className="flex flex-col">
      <div className="flex items-center gap-5">
        <img className="p-2.5 w-24 h-24" src={LogoLocavibeBase64} alt="Logo" />

        <h1 className="text-xl font-semibold text-center flex-1">
          TERMO DE RESPONSABILIDADE PELO USO, GUARDA E CONSERVAÇÃO DE
          EQUIPAMENTOS
        </h1>
      </div>
    </div>
  );
};
